import React from 'react';

import { ServiceHourDay } from './ServiceHourDay';

import { Hours } from 'olo-service';

import styles from './ServiceHoursModal.module.scss';

type ServiceHoursListProps = {
  serviceHours?: Hours;
  timezone: string;
};

export const ServiceHoursList: React.FC<ServiceHoursListProps> = ({ serviceHours, timezone }) => {
  if (!serviceHours) return null;

  return (
    <dl className={styles.content}>
      {Object.entries(serviceHours).map(([day, hours]) => (
        <ServiceHourDay key={day} day={day} hours={hours} timezone={timezone} />
      ))}
    </dl>
  );
};
